import { ACQUIRER, weightedBinVamp } from "./acquirer";
import {
  buildActivity,
  buildEthoca,
  buildEvidence,
  buildIntel,
  buildSubscribers,
  buildThreeDs,
  buildTc40,
} from "./events";
import { buildSiteAudits } from "./siteAudit";
import { generateAllData } from "./simulation";
import type { Portfolio } from "./types";

export function buildPortfolio(): Portfolio {
  const now = "2026-04-24T06:15:00Z";
  const { merchantSummaries, allMonthly } = generateAllData();
  const tc40 = buildTc40(merchantSummaries, allMonthly);
  const ethoca = buildEthoca(merchantSummaries, now);
  const evidence = buildEvidence(tc40);
  const subscribers = buildSubscribers(merchantSummaries);
  const threeDs = buildThreeDs(merchantSummaries);
  const intel = buildIntel(merchantSummaries);
  const siteAudits = buildSiteAudits(merchantSummaries);
  const activity = buildActivity({ now, merchants: merchantSummaries, tc40, ethoca });

  const rolling12moVamp = weightedBinVamp(ACQUIRER);
  const weekSecuredEur = 2_843_000;
  const ytdSecuredEur = 14_210_000;
  const tc40SuppressedGbpWeek = 12_400;
  const interventionsWeek = { fired: 18, accepted: 16 };

  return {
    now,
    acquirer: ACQUIRER,
    merchants: merchantSummaries,
    monthly: allMonthly,
    tc40,
    ethoca,
    evidence,
    subscribers,
    threeDs,
    intel,
    activity,
    siteAudits,
    rolling12moVamp,
    weekSecuredEur,
    ytdSecuredEur,
    tc40SuppressedGbpWeek,
    interventionsWeek,
  };
}

export * from "./types";
export { ACQUIRER } from "./acquirer";
export { MERCHANT_DEFS } from "./merchants";
export { MITS_DEF } from "./interventions";
export { MCC_RAMP, MCC_ATV, MCC_VISA, NOW_YYYYMM } from "./seasonality";
